import getCustomQuestions, {
  GetCustomQuestionsResponse,
} from 'api/experience/useCustomQuestions/getCustomQuestions';
import { GetCustomQuestionsPublicEndpoint } from '@kouto/types';
import useSWR from 'swr';

type useCustomQuestionsProps = {
  brandId?: string | null;
  experienceId?: string | null;
  skip?: boolean;
  includeDefault?: boolean;
  language?: string;
};

const useCustomQuestions = ({
  brandId,
  experienceId,
  skip = false,
  includeDefault,
  language,
}: useCustomQuestionsProps) => {
  const url =
    skip || !brandId || !experienceId
      ? null
      : GetCustomQuestionsPublicEndpoint.url({
          brandId,
          experienceId,
          query: {
            includeDefault,
            language,
          },
        });
  const swr = useSWR<GetCustomQuestionsResponse['items']>(
    url,
    getCustomQuestions,
  );

  return swr;
};

export default useCustomQuestions;
